import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Typography,
} from "@mui/material";

const DoctorCard = (props: {
  doctorInfo: any;
  medicoId: string;
  doctorImage: any;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        maxHeight: "100%",
        width: "flex",
        border: "1px solid lightgrey",
        borderRight: "none",
      }}
    >
      <Card className="card" key={props.medicoId}>
        <CardContent sx={{ maxHeight: "100%" }}>
          <Box display="flex" justifyContent="center" mt={2}>
            <CardMedia
              component="img"
              sx={{
                height: {
                  xs: 100,
                  sm: 140,
                  md: 160,
                },
                width: {
                  xs: 100,
                  sm: 140,
                  md: 160,
                },
                marginBottom: 3,
              }}
              image={props.doctorImage}
              title={props.doctorInfo.nominativoMedico}
            />
          </Box>
          <Box display="flex" justifyContent="start" mb={1}>
            <Chip
              size="small"
              className="buttonCard"
              label={props.doctorInfo.struttura}
            />
          </Box>
          <Box display="flex" justifyContent="start" mb={1}>
            <Chip
              size="small"
              className="buttonCard"
              label={props.doctorInfo.tipologiaAgenda}
            />
          </Box>
          <Box textAlign={"start"} mb={1} textTransform={"capitalize"}>
            <Typography
              variant="h6"
              component="div"
              className="typography"
              fontWeight={"bold"}
              sx={
                props.doctorInfo.nominativoMedico.length > 16
                  ? { fontSize: 15 }
                  : { fontSize: 16 }
              }
            >
              {props.doctorInfo.nominativoMedico}
            </Typography>
            {/* <Typography
              variant="body2"
              className="typography"
              textTransform={"capitalize"}
            >
              {props.doctorInfo.sede}
            </Typography> */}
            {/* <Typography
              variant="body2"
              className="typography"
              fontWeight={"bold"}
            >
              {props.doctorInfo.sedeIndirizzo}
            </Typography> */}
          </Box>
          <Box display="flex" justifyContent="start" mt={1}>
            <Chip
              variant="outlined"
              size="small"
              className="buttonCard"
              label={`${
                props.doctorInfo.tariffa.length >= 1
                  ? props.doctorInfo.tariffa
                  : "50,00"
              } €`}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DoctorCard;
